export default __webpack_public_path__ + "static/media/Profile.380ec4fd.svg";